module.exports = __webpack_public_path__ + "static/media/add.237ecc2d.svg";